/**
 * La entrada del Inicio también sale «la primera vez que entrás al Inicio en cada sesión» (card #585;
 * Emmanuel, 21/10). Además, siempre, al volver de «¡Despegaste!».
 *
 * Qué es una sesión: desde que se abre la app, o cuando vuelve después de `SESSION_GAP_MS` o más sin
 * usarla (app en segundo plano o pestaña escondida). Recargar la página no empieza una sesión nueva
 * (`sessionStorage` sobrevive al recargar; una pestaña o una app recién abiertas empiezan vacías). Así
 * ir a la Biblioteca y volver, cambiar de pestaña o salir menos de 30 minutos no la repite.
 */
export const SESSION_GAP_MS = 30 * 60 * 1000;
const SEEN_KEY = 'speak.homeEntrance.seen';
const HIDDEN_KEY = 'speak.homeEntrance.hiddenAt';

const onNew = new Set<() => void>();
let listening = false;
function listen(): void {
  if (listening) return;
  listening = true;
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      sessionStorage.setItem(HIDDEN_KEY, String(Date.now()));
      return;
    }
    const hiddenAt = Number(sessionStorage.getItem(HIDDEN_KEY));
    sessionStorage.removeItem(HIDDEN_KEY);
    if (hiddenAt && Date.now() - hiddenAt >= SESSION_GAP_MS) {
      sessionStorage.removeItem(SEEN_KEY);
      onNew.forEach((cb) => cb());
    }
  });
}

/** ¿Le toca la entrada a esta visita al Inicio? La primera de la sesión la «reclama»; las demás, no. */
export function claimSessionEntrance(): boolean {
  listen();
  if (sessionStorage.getItem(SEEN_KEY)) return false;
  sessionStorage.setItem(SEEN_KEY, String(Date.now()));
  return true;
}

/** Avisa cuando empieza una sesión nueva con la app abierta (volvió después de 30 minutos o más). */
export function onNewSession(cb: () => void): () => void {
  listen();
  onNew.add(cb);
  return () => onNew.delete(cb);
}
